/**
 * Uyarı önem derecesi → Tailwind class token'ları (#229).
 * Kart, ikon zemini ve rozet aynı haritayı paylaşır.
 */
const SEVERITY_STYLES = {
  danger: {
    accent: "from-red-500 to-rose-400",
    tile: "bg-red-50 text-red-600 ring-red-100",
    badge: "bg-red-50 text-red-700 ring-red-200",
    glow: "group-hover:shadow-red-100",
    count: "text-red-600",
  },
  warning: {
    accent: "from-amber-500 to-orange-400",
    tile: "bg-amber-50 text-amber-600 ring-amber-100",
    badge: "bg-amber-50 text-amber-700 ring-amber-200",
    glow: "group-hover:shadow-amber-100",
    count: "text-amber-600",
  },
  info: {
    accent: "from-sky-500 to-indigo-400",
    tile: "bg-sky-50 text-sky-600 ring-sky-100",
    badge: "bg-sky-50 text-sky-700 ring-sky-200",
    glow: "group-hover:shadow-sky-100",
    count: "text-sky-600",
  },
  clear: {
    accent: "from-gray-200 to-gray-100",
    tile: "bg-gray-50 text-gray-400 ring-gray-100",
    badge: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    glow: "",
    count: "text-gray-300",
  },
};

export default function getSeverityStyles(severity, isClear = false) {
  if (isClear) return SEVERITY_STYLES.clear;
  return SEVERITY_STYLES[severity] || SEVERITY_STYLES.info;
}
